<template>
	<div id="multiselectdesires" class="mt2">
		<div class="dropdown dropdown-filter" @click="showDropdown">
			<div class="overselect"></div>
			<div class="c-form-input">
				<h3 class="raleway-semi-p13">Vos envies</h3>
				<img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
				<img src="../../images/flechebas-simple.svg" v-set-alt v-else />
			</div>
		</div>
    <div class="multiselect" v-if="show && desiresMount">
      <ul>
        <div class="row-selectoptions mt-3" :class="{ row: !isPhone }">
          <div
              :class="{ 'col-12': !isPhone }"
              v-for="(desire, index) in desiresMount"
              :key="index"
          >
            <li>
              <input
                  type="checkbox"
                  :id="desire.name"
                  :value="desire.id"
                  v-model="selected"
              />
              <label
                  :class="{ 'ml-2': !isPhone }"
                  class="raleway-reg-p13"
                  :for="desire.name"
              >
                {{ formatStyle(desire.name) }} <span v-if="getDesireCount(desire.id)" class="filter-count">({{ getDesireCount(desire.id) }})</span>
              </label>
            </li>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'multiselectdesires',
		props: ['options', 'desiresMount', 'filterCounts'],
		data() {
			return {
				show: false,
				selected: [],
			};
		},
		methods: {
			formatStyle(value) {
				return value.charAt(0).toUpperCase() + value.slice(1);
			},
			showDropdown() {
				this.show = !this.show;
			},
			getDesireCount(desireId) {
				if (!this.filterCounts || !this.filterCounts.desire_ids) return 0;
				const desireData = this.filterCounts.desire_ids.find(d => d.key === desireId);
				return desireData ? desireData.count : 0;
			},
		},
		watch: {
			selected(val) {
				this.$emit('checked', val, 'desires');
			},
		},
  computed: {
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
  }
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
